<p-table
  [value]="tableData"
  [rows]="rowsPerPage || paginator?.per_page"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  [columns]="tableHeader"
  styleClass="p-datatable-customers  p-datatable-responsive-demo"
  [paginator]="frontendPaginator"
  [(selection)]="selectedRows"
  (onRowSelect)="onRowSelect()"
  (selectAllChange)="onRowSelect()"
  class="main-table-component"
>
  <ng-template pTemplate="caption">
    <!-- <app-filter-container> -->
    <ng-content select="[filters]"></ng-content>
    <!-- </app-filter-container> -->
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr style="height: 4rem">
      <th style="width: 3rem" *ngIf="enableRowSelect">
        <div (click)="onRowSelect()">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>
      <ng-container *ngFor="let col of columns">
        <th
          [style]="col.options?.width"
          class="sort-button"
          (click)="onSort(col)"
        >
          <div class="flex align-items-center cursor-pointer">
            {{ col.header }}

            <span *ngIf="col.sort">
              <i
                class="pi pi-sort-amount-down ml-1"
                *ngIf="col.sort.sortDirection === 'desc'"
                [ngClass]="{ 'active-sort-button': col.sort.activeSort }"
              ></i>
              <i
                class="pi pi-sort-amount-up ml-1"
                *ngIf="col.sort.sortDirection === 'asc'"
                [ngClass]="{ 'active-sort-button': col.sort.activeSort }"
              ></i>
            </span>
          </div>
        </th>
      </ng-container>
      <th style="width: 8rem" *ngIf="options.showSwitch">
        <div class="flex justify-content-center align-items-center">
          {{ options.switchText || "LAYOUT.public" }}
        </div>
      </th>
      <th style="width: 5rem" *ngIf="options.showStatus">
        <div
          class="flex justify-content-center align-items-center hiddeTableStatus"
        >
          Status
        </div>
      </th>
      <th
        style="width: 8rem"
        *ngIf="
          options.showEdit ||
          options.showDelete ||
          options.showPreview ||
          options.showModal ||
          options.showCopy
        "
      >
        <div class="flex justify-content-center align-items-center">Akcije</div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-rowData
    let-i="rowIndex"
    let-columns="columns"
  >
    <tr
      class="h-4rem"
      [ngClass]="'nip-background-priority-' + rowData?.colorPriority"
    >
      <td *ngIf="enableRowSelect" (click)="onRowSelect()">
        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns">
        <!-- Header with/without filter -->
        <!-- <span class="p-column-title">{{ col.header }}</span> -->
       <span *ngIf="col.isLink">
        <a [routerLink]="col.linkFunction(rowData)">
          {{ rowData[col.field] }}
        </a>
       </span>
        <span
          *ngIf="
            !col?.image &&
            !col?.url &&
            !col?.status &&
            !col?.date &&
            !col?.custom &&
            !col?.isLink &&
            col.field !== 'workNipStatus'
          "
        >
          {{ rowData[col.field] }}
        </span>
        <ng-container *ngIf="col.field == 'workNipStatus'">
          <p
            class="flex align-items"
            *ngIf="rowData[col.field] === 'Stopiran'"
            style="color: #d11515"
          >
            <i class="pi pi-times-circle mr-2"></i>
            <span> {{ rowData[col.field] }}</span>
          </p>

          <p
            class="flex align-items"
            *ngIf="rowData[col.field] === 'Aktivan'"
            style="color: #11a616"
          >
            <i class="pi pi-check-circle mr-2"></i>
            <span> {{ rowData[col.field] }}</span>
          </p>
        </ng-container>

        <span
          *ngIf="!rowData[col.field] && rowData[col.field] !== 0"
          class="text-xs bg-gray-400 border-round py-1 px-1 font-italic"
        >
          Nema podataka
        </span>
        <ng-container *ngIf="col?.image">
          <img [src]="rowData[col.field]" style="width: 100%; height: auto" />
        </ng-container>
        <ng-container *ngIf="col?.date">
          <span>{{ rowData[col.field] | date : "dd.MM.yyyy, HH:mm:ss" }}</span>
        </ng-container>

        <ng-container *ngIf="col?.custom && rowData[col.field]">
          <ng-container *ngIf="rowData[col.field].type === 'buttons'">
            <div class="flex justify-content-center">
              <button
                *ngFor="let item of rowData[col.field].elements"
                class="second-btn small-btn mr-2"
                type="button"
                [pTooltip]="item.tooltip"
                tooltipPosition="top"
                (click)="proxyClick($event, rowData, item?.action)"
              >
                <i [class]="item.icon"></i>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="rowData[col.field].type === 'switch'">
            <div class="flex justify-content-center">
              <p-inputSwitch
                *ngFor="let item of rowData[col.field].elements"
                [ngModel]="item.status"
                (click)="proxyClick($event, rowData, item?.action)"
              ></p-inputSwitch>
            </div>
          </ng-container>

          <ng-container *ngIf="rowData[col.field].type === 'dropdown'">
            <div class="flex justify-content-center">
              <p-dropdown
                *ngFor="let item of rowData[col.field].elements"
                [options]="item?.options?.dropdownOptions"
                [placeholder]="item?.options?.placeholder"
                [optionValue]="item?.options?.optionValue"
                styleClass="w-full"
                (onChange)="proxyClick($event, rowData, item?.action)"
                [showClear]="false"
              ></p-dropdown>
            </div>
          </ng-container>
          <ng-container *ngIf="rowData[col.field].type === 'chip'">
            <div
              *ngIf="rowData[col.field].value"
              class="p-2 bg-red-50 text-red-400 w-fit text-xs border-round-md"
            >
              {{ rowData[col.field].value }}
            </div>
          </ng-container>
          <ng-container *ngIf="rowData[col.field].type === 'html'">
            <p-overlayPanel #op>
              <div *ngFor="let item of rowData[col.field].elements">
                <pre [innerHTML]="item.html"></pre>
              </div>
            </p-overlayPanel>
            <button
              (click)="op.toggle($event)"
              [pTooltip]="rowData[col.field]?.tooltip"
              tooltipPosition="top"
              class="second-btn small-btn"
              type="button"
            >
              <i class="pi pi-eye"></i>
            </button>
          </ng-container>
          <ng-container *ngIf="rowData[col.field].type === 'image'">
            <p-overlayPanel #op>
              <img
                *ngFor="let item of rowData[col.field].elements"
                [src]="item.src"
                alt="Image"
                style="width: 300px; height: auto"
              />
            </p-overlayPanel>

            <img
              (click)="op.toggle($event)"
              [src]="rowData[col.field].elements[0]?.src"
              alt="Image"
              style="width: 30px; height: auto"
              class="cursor-pointer"
            />
          </ng-container>
        </ng-container>

        <ng-container *ngIf="col?.status && rowData[col.field]">
          <span>{{
            rowData[col.field] === 1 ? "Isporučen" : "Neisporučeno"
          }}</span>
        </ng-container>
        <ng-container *ngIf="col?.url">
          <a *ngIf="rowData['url']" [href]="rowData['url']" target="_blank">
            <span> {{ rowData[col.field] }}</span>
          </a>
        </ng-container>
      </td>
      <td *ngIf="options.showSwitch">
        <section class="p-d-flex p-ai-center p-jc-center">
          <span class="p-column-title">
            {{ options.switchText || "LAYOUT.public" }}
          </span>
          <p-inputSwitch
            *ngIf="!rowData?.schedule_date"
            [ngModel]="rowData.status || false"
            (onChange)="onChangeStatus($event, rowData.id)"
            [name]="rowData.status + i"
          ></p-inputSwitch>
          <span *ngIf="rowData?.schedule_date"
            >{{ "STATIC.scheduled" }}:
            <span class="block">{{
              rowData?.schedule_date | date : "d.M.y, HH:mm:ss"
            }}</span></span
          >
        </section>
      </td>

      <td *ngIf="options.showStatus">
        <ng-container *ngIf="options.showStatus">
          <span class="p-column-title"> Status </span>
          <div>
            <button
              class="second-btn small-btn mr-2"
              [ngClass]="[
                'bg-' + rowData.status.color + '-100',
                'text-' + rowData.status.color + '-600'
              ]"
              type="button"
              [pTooltip]="rowData.status.tooltip"
              tooltipPosition="top"
            >
              <i class="inline-block" [class]="rowData.status.icon"></i>
              <span class="inline-block ml-2 sm:hidden">{{
                rowData.status.tooltip
              }}</span>
            </button>
          </div>
        </ng-container>
      </td>

      <td
        *ngIf="
          options.showEdit ||
          options.showDelete ||
          options.showPreview ||
          options.showModal ||
          options.showCopy
        "
      >
        <!-- <span class="p-column-title">{{ actionLabel }}</span> -->
        <div class="w-btn-group flex">
          <ng-container *ngIf="options.showEdit">
            <ng-container
              *ngIf="editPath === 'post_template'; else elseTemplate"
            >
              <a
                class="second-btn small-btn mr-2"
                pTooltip="Izmeni"
                tooltipPosition="top"
                [routerLink]="[editPath, rowData.id]"
                queryParamsHandling="merge"
              >
                <i class="pi pi-pencil"></i>
              </a>
            </ng-container>
            <ng-template #elseTemplate>
              <a
                class="second-btn small-btn mr-2"
                pTooltip="Izmeni"
                tooltipPosition="top"
                [routerLink]="[editPath, rowData.id]"
                queryParamsHandling="merge"
              >
                <i class="pi pi-pencil"></i>
              </a>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="options.showPreview && !rowData.hidePreview">
            <button
              class="second-btn small-btn mr-2"
              type="button"
              pTooltip="Pregledaj"
              tooltipPosition="top"
              (click)="previewRow($event, rowData)"
            >
              <i class="pi pi-eye"></i>
            </button>
          </ng-container>

          <ng-container *ngIf="options.showClone">
            <a
              *ngIf="
                rowData.allowClone === true || rowData.allowClone === undefined
              "
              class="second-btn small-btn mr-2"
              [pTooltip]="'BUTTONS.clone'"
              tooltipPosition="top"
              [routerLink]="
                editPath === 'post_template'
                  ? [rowData[editPath], rowData.id]
                  : [editPath, rowData.id]
              "
              [queryParams]="{ clone: true }"
            >
              <i class="pi pi-copy"></i>
            </a>
          </ng-container>

          <ng-container *ngIf="options.showModal">
            <ng-container>
              <button
                class="second-btn small-btn mr-2"
                pTooltip="Izmeni"
                tooltipPosition="top"
                (click)="openModal($event, rowData)"
              >
                <i class="pi pi-file-edit"></i>
              </button>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="options.showCopy">
            <ng-container>
              <button
                class="second-btn small-btn mr-2"
                pTooltip="Kopiraj kod"
                tooltipPosition="top"
                (click)="copyToClipboard($event, rowData)"
              >
                <i class="pi pi-file"></i>
              </button>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="options.showDelete">
            <button
              *ngIf="
                rowData.allowDelete === true ||
                rowData.allowDelete === undefined
              "
              class="second-btn small-btn mr-2"
              type="button"
              pTooltip="Obriši"
              tooltipPosition="top"
              (click)="deleteRow($event, rowData.id)"
            >
              <i class="pi pi-trash"></i>
            </button>
          </ng-container>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="numberOfCols">Nema dostupnih podataka za prikaz.</td>
    </tr>
  </ng-template>
</p-table>
<p-paginator
  #paginatorElement
  *ngIf="paginator"
  [first]="1"
  styleClass="mb-4"
  [rows]="100"
  [showJumpToPageDropdown]="true"
  [showPageLinks]="true"
  [totalRecords]="paginator.total"
  (onPageChange)="onPageChange($event)"
  [showPageLinks]="false"
  [rowsPerPageOptions]="[10, 50, 100, 250]"
></p-paginator>
<!-- * Confirmation popup -->
<p-confirmPopup styleClass="p-shadow-2"></p-confirmPopup>
